import {
    SETTINGS_REQUEST,
    SETTINGS_RECEIVE
} from './actions';

const settings = (state = {
    isFetching: false,
    didInvalidate: true,
    orderSubjects: null,
    orderTypes: null,
    orderTimes: ['all', '3hours', '5hours', '12hours', '24hours', 'yesterday', 'lastWeek'],
    orderTimesWithNew: ['all', 'new', '3hours', '5hours', '12hours', '24hours', 'yesterday', 'lastWeek'],
    filterTimesLong: ['all', 'thisMonth', 'lastMonth', 'thisYear', 'lastYear'],
    writerGroups: [null, 'newbie', 'red', 'basic', 'silver', 'gold'],
    templates: {
        guides: {
            id: 'guides',
            text: 'Guides',
            location: '/help/guides/general'
        },
        apa: {
            id: 'apa',
            text: 'APA template',
            location: 'https://shift-files.s3.amazonaws.com/000/APA+template.docx'
        },
        chicago: {
            id: 'chicago',
            text: 'Chicago template',
            location: 'https://shift-files.s3.amazonaws.com/000/Chicago+template.docx'
        },
        harvard: {
            id: 'harvard',
            text: 'Harvard template',
            location: 'https://shift-files.s3.amazonaws.com/000/Harvard+template.docx'
        },
        mla: {
            id: 'mla',
            text: 'MLA template',
            location: 'https://shift-files.s3.amazonaws.com/000/MLA+template.docx'
        }
    }
}, action) => {
    switch (action.type) {
        case SETTINGS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case SETTINGS_RECEIVE:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                orderSubjects: action.orderSubjects,
                orderTypes: action.orderTypes
            });
        default:
            return state;
    }
};

export default settings;


// WEBPACK FOOTER //
// ./src/store/settings/reducers.js